import React from "react";

/**
 * MatchBadge — Score circolare "[X]% Match", theme-adaptive.
 * - >80: verde (High match)
 * - 60-80: oro
 * - <60: neutro grigio
 *
 * Light theme: sfondo chiaro (white/gray-50), bordo e testo colorato, ombra soft
 * Dark theme:  sfondo scuro, glow neon tenue del colore
 */
export default function MatchBadge({ score, size = "sm", className = "" }) {
    if (score == null) return null;
    const s = Math.max(0, Math.min(100, Math.round(score)));
    const tier = s >= 80 ? "high" : s >= 60 ? "mid" : "low";

    const dims = size === "lg"
        ? { w: "w-16 h-16", num: "text-lg", lbl: "text-[8px]" }
        : size === "md"
        ? { w: "w-12 h-12", num: "text-sm", lbl: "text-[7px]" }
        : { w: "w-11 h-11", num: "text-xs", lbl: "text-[7px]" };

    return (
        <div
            data-testid={`match-badge-${tier}`}
            data-tier={tier}
            title={`${s}% di compatibilità con le tue preferenze`}
            className={`match-badge match-badge--${tier} ${dims.w} rounded-full flex flex-col items-center justify-center font-bold shadow-lg backdrop-blur-md leading-none select-none ${className}`}
            role="img"
            aria-label={`${s} per cento match`}
        >
            <span className={`${dims.num} tabular-nums`}>{s}%</span>
            <span className={`${dims.lbl} uppercase tracking-widest opacity-80 mt-0.5`}>Match</span>
        </div>
    );
}
